export const SET_SELECTED_QUOTE = 'SET_SELECTED_QUOTE'

// wizard step - quotes
export const LOAD_MODELS_BY_MAKE_AND_YEAR = 'LOAD_MODELS_BY_MAKE_AND_YEAR'
export const CHECK_VIN_INFORMATION = 'CHECK_VIN_INFORMATION'
export const SET_QUOTE_LIST = 'SET_QUOTE_LIST'
export const SET_WEB_QUOTE_QUEUE = 'SET_WEB_QUOTE_QUEUE'
export const ADD_NEW_QUOTE = 'ADD_NEW_QUOTE'
export const UPDATE_QUOTE = 'UPDATE_QUOTE'

// third party - quotes
export const DECLINE_INITIAL_QUOTE = 'DECLINE_INITIAL_QUOTE'
export const UNSET_DECLINE_INITIAL_QUOTE = 'UNSET_DECLINE_INITIAL_QUOTE'
export const DOBULE_DECLINE_INITIAL_QUOTE = 'DOBULE_DECLINE_INITIAL_QUOTE'
export const SET_CALLBACK_QUOTE = 'SET_CALLBACK_QUOTE'
export const UNSET_CALLBACK_QUOTE = 'UNSET_CALLBACK_QUOTE'
export const SET_ACCEPTED_QUOTE = 'SET_ACCEPTED_QUOTE'
export const UNSET_ACCEPTED_QUOTE = 'UNSET_ACCEPTED_QUOTE'
export const SET_QUOTE_STATUS = 'SET_QUOTE_STATUS'
export const SET_SUGGESTED_OFFER = 'SET_SUGGESTED_OFFER'

// quotes wizard
export const SET_CURRENT_WIZARD_STEP = 'SET_CURRENT_WIZARD_STEP'
export const MOVE_WIZARD_BACK = 'MOVE_WIZARD_BACK'
export const SET_NEXT_DISABLED = 'SET_NEXT_DISABLED'
export const SET_BACK_DISABLED = 'SET_BACK_DISABLED'

export const SET_CURRENT_STEP = 'SET_CURRENT_STEP'
export const SET_FLOW_CURRENT_STEP = 'SET_FLOW_CURRENT_STEP'
export const SET_QUOTE_LAST_CURRENT_STEP = 'SET_QUOTE_LAST_CURRENT_STEP'
export const SET_QUOTE_LAST_CURRENT_FLOW_STEP = 'SET_QUOTE_LAST_CURRENT_FLOW_STEP'
export const RESET_WIZARD = 'RESET_WIZARD'

export const SET_SELECTED_QUOTE_ADMIN = 'SET_SELECTED_QUOTE_ADMIN'
export const SET_SELECTED_CALL_CODE_WIZARD = 'SET_SELECTED_CALL_CODE_WIZARD'

export const SET_COMPONENTS_FOR_VEHICLE = 'SET_COMPONENTS_FOR_VEHICLE'
export const SET_PARTS_DISPLAY = 'SET_PARTS_DISPLAY'
export const SET_QUOTE_PICKUP_LOCATION = 'SET_QUOTE_PICKUP_LOCATION'
export const SET_THIRD_PARTY = 'SET_THIRD_PARTY'
export const SET_LIEN = 'SET_LIEN'

export const SET_SAVESTEP1_DATA = 'SET_STEP1_DATA'
export const SET_SAVESTEP2_DATA = 'SET_STEP2_DATA'
export const SET_SAVESTEP8_DATA = 'SET_STEP8_DATA'
export const SET_SAVESTEP9_DATA = 'SET_STEP9_DATA'
export const SET_FOLLOWUP_QUOTE = 'SET_FOLLOWUP_QUOTE'
export const SET_VERIFIED_QUOTE = 'SET_VERIFIED_QUOTE'

export const SET_SKIP_EXIT_CONFIRMATION = 'SET_SKIP_EXIT_CONFIRMATION'
export const SET_REMOTE_QUOTE_ID = 'SET_REMOTE_QUOTE_ID'

export const SET_SCREEN_POP = 'SET_SCREEN_POP'
export const SET_CALL_INFORMATION = 'SET_CALL_INFORMATION'


// WEBPACK FOOTER //
// ./src/store/modules/wizard/mutation-types.js